import React from 'react'

import FormControlled from 'common/Forms/Base/FormControlled'
import NumberControl from 'common/NumberControl'

export default props => <FormControlled tag={NumberControl} {...props} />
